<template>
	<div id="zhjl" v-loading="loading">
		<div class="zhjl_main">
			<!-- 彩票类型 -->
			<div class="query_info">
				<!-- 选择游戏 -->
				<el-select v-model="currChooseGame" placeholder="请选择游戏">
					<el-option v-for="item in game" :key="item.LgId" :label="item.Name" :value="item.LgId" />
				</el-select>
				<el-input v-model="orderNum" placeholder="请输入追号编号" />
				<!-- 订单状态 -->
				<el-select v-model="currOrderType" placeholder="请选择订单状态">
					<el-option v-for="item in orderType" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>

				<div class="input-br" />
				<el-date-picker v-model="beginDate" type="datetime" placeholder="开始日期" class="czdateStyle" />
				<el-date-picker v-model="endDate" type="datetime" placeholder="结束日期" class="czdateStyle" />
				<el-button class="el-button--primary" @click="zhCxBtn">搜索</el-button>
			</div>
			<!-- 彩票的表格 -->
			<div class="czTable">
				<!-- 彩票表格 -->
				<el-table :data="czTableData" border stripe style="width: 100%">
					<el-table-column prop="ZhNumber" width="190" label="追号编号" />
					<el-table-column prop="LgName" label="彩种" />
					<el-table-column prop="LpName" label="玩法" width="100" />
					<el-table-column prop="BetTime" label="下注时间" width="170" />
					<el-table-column prop="BetMoney" label="投注总金额" width="100" />
					<el-table-column prop="OpenD" label="开奖进度" width="80" />
					<el-table-column prop="StatusText" label="状态" width="60">
						<template slot-scope="scope">
							<span class="unpaidState" v-if="scope.row.StatusText === '未开始'">{{ scope.row.StatusText }}</span>
							<span class="payState" v-if="scope.row.StatusText === '进行中'">{{ scope.row.StatusText }}</span>
							<span class="cancelState" v-if="scope.row.StatusText === '已撤销'">{{ scope.row.StatusText }}</span>
							<span v-if="scope.row.StatusText === '已完成'">{{ scope.row.StatusText }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作项" align="center" width="70">
						<template slot-scope="scope">
							<div @click="seeDetail(scope.$index, scope.row)" class="detail_style">详情</div>
						</template>
					</el-table-column>
					<div slot="empty">
						<!-- 表格为空的样式 -->
						<div class="table-empty">
							<img src="@/static/img/zjzh/empty.webp" alt="" />
							<div class="table-empty-text">暂无记录</div>
						</div>
					</div>
				</el-table>
			</div>
			<div class="my-paging" v-show="czTableData.length != 0">
				<div class="everyPageShow">每页显示 10 条</div>
				<div class="totalNum">共{{ paginationArray.total }}条</div>

				<el-pagination
					@current-change="handleCurrentChange"
					:page-size="paginationArray.currpageSize"
					layout="prev, pager, next, jumper"
					:total="paginationArray.total"
					background
				/>
			</div>
		</div>

		<DialogDetail :zhdata="detailData" ref="DialogDetail" @list="zhCxBtn"></DialogDetail>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";
import OrderCancel from "@/components/Elasticframe/OrderCancel";
import DialogDetail from "@/components/Elasticframe/zhdetails";

export default {
	components: { OrderCancel, DialogDetail },
	data() {
		return {
			loading: false,
			cancelOrderType: 0,
			cancelOrderTips: "",
			curCancelOrder: null,
			//显示弹框
			dialogVisible: false,
			//当前彩票类型
			currLotteryType: 1,
			// 订单状态
			orderType: [
				{ value: "", label: "请选择" },
				{ value: "1", label: "进行中" },
				{ value: "2", label: "已撤销" },
				{ value: "3", label: "已完成" },
			],
			currOrderType: "",
			//游戏类型
			game: [],
			currChooseGame: "",
			//投注期号
			betIssue: "",
			//订单编号
			orderNum: "",
			//日期
			beginDate: "",
			endDate: "",
			//表格数据
			czTableData: [],
			paginationArray: {
				total: 0,
				currpageSize: 10,
				currPage: 1, //当前页数
			},
			//每页展示多少条
			pageSize: [
				{ value: 10, label: "10条" },
				{ value: 20, label: "20条" },
				{ value: 30, label: "30条" },
			],
			//追号详情
			detailData: [],
			//追号详情表格外的数据
			detailOut: {},
			//自己计算的详情的总的金额和总的亏盈
			calcSelf: {
				canCancelAll: false,
				totalMoney: 0,
				totalKuiYing: 0,
			},
		};
	},
	mounted() {
		let etad = new Date();
		let y = etad.getFullYear();
		let m = ("00" + (etad.getMonth() + 1)).slice(-2);
		let d = etad.getDate();
		let h = etad.getHours();
		d = h > 3 ? d : d - 1;
		this.beginDate = `${y}-${m}-${("00" + d).slice(-2)} 03:00:00`;
		this.endDate = `${y}-${m}-${("00" + (d + 1)).slice(-2)} 03:00:00`;
		this.getGameType();
		this.zhCxBtn();
	},
	methods: {
		cancelOrderConfirm() {
			if (this.cancelOrderType == 1) {
				let url = "api/Bet/CancleOrder?number=" + this.curCancelOrder.OrderNumber + "&type=1";
				postAjax(url).then(data => {
					this.$message.success("已成功取消订单");
					this.dialogVisible = false;
				});
			} else if (this.cancelOrderType == 2) {
				let that = this;
				let url = "api/Bet/CancleOrder?number=" + this.detailData[0].ZhNumber + "&type=2";
				postAjax(url).then(function (data) {
					if (data.Data == false) {
						// that.openFail()
						that.$message.error("终止全部追号失败");
					} else if (data.Data == true) {
						// that.openSucc()
						that.$message({
							message: "终止全部追号成功",
							type: "success",
						});
						that.zhCxBtn();
					}
					that.dialogVisible = false;
				});
			}
		},
		//停止全部追号
		stopNum() {
			this.cancelOrderType = 2;
			this.cancelOrderTips = `全部`;
			this.$refs.OrderCancel.show();
		},
		//改变分页条数
		pageChange(val) {
			this.paginationArray.currpageSize = val;
			this.zhCxBtn();
		},
		//改变当前选中的彩票类型
		changeType(num) {
			this.currLotteryType = num;
		},
		//得到所有游戏类型
		getGameType() {
			let that = this;
			let url = "api/lnc/get";

			getAjax(url, null)
				.then(data => {
					let tempArry = [{ Name: "全部", LgId: "" }];
					if (data.IsSucess) {
						for (let i = 0, length = data.Data.length; i < length; i++) {
							tempArry.push(...data.Data[i].LotteryList);
						}
						that.game = tempArry;
					}
				})
				.catch(() => {});
		},
		//查询
		zhCxBtn() {
			let that = this;
			if (this.currLotteryType == 1) {
				let url = "api/Order/PZhHistoryinfo";
				let data = {
					OrderNumber: this.orderNum,
					LgId: this.currChooseGame,
					Lssue: this.betIssue,
					StartTime: this.beginDate,
					EndTime: this.endDate,
					Status: this.currOrderType,
					PIndex: this.paginationArray.currPage,
					PSize: this.paginationArray.currpageSize,
				};
				this.loading = true;
				postAjax(url, data)
					.then(data => {
						this.loading = false;
						if (data.IsSucess) {
							that.czTableData = data.Data.rows;
							that.paginationArray.total = data.Data.total;
						}
					})
					.catch(() => {
						this.loading = false;
					});
			}
		},
		//撤单
		cancelOrder(index, row) {
			this.cancelOrderType = 1;
			this.curCancelOrder = row;
			this.cancelOrderTips = `${row.LgName} ${row.Lssue}期`;
			this.$refs.OrderCancel.show();
		},
		//点击详情按钮
		seeDetail(index, row) {
			let that = this;
			//请求详情数据接口
			let url = "api/Order/GetDetailByOrderNumber?number=" + row.ZhNumber + "&type=" + 2;
			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					let allmoney = 0; //总金额
					let ykmoney = 0; //盈亏金额
					//计算总金额
					data.Data.forEach(item => {
						allmoney += item.BetMoney;
						ykmoney += item.WinBonus - item.BetMoney;
					});
					//添加到第一个数组
					data.Data[0]["allMoney"] = allmoney;
					data.Data[0]["ykMoney"] = ykmoney;
					that.detailData = data.Data;
					that.$refs.DialogDetail.dialogVisible = true;
				}
			});
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.paginationArray.currPage = e;
			this.zhCxBtn();
		},
		//时间格式化
		formatDate(row, column) {
			if (row[column.property]) {
				var arr = row[column.property].split("T");
				var arr1 = arr[1].split(".");
				return arr[0] + " " + arr1[0];
			} else {
				return "-";
			}
		},
	},
	//过滤器
	filters: {
		splitNum(val) {
			if (val) {
				return val.split(",").join(" ");
			}
		},
		formatDate(val) {
			if (val) {
				var arr = val.split("T");
				var arr1 = arr[1].split(".");
				return arr[0] + " " + arr1[0];
			}
		},
		toFiexd(val) {
			if (val && val != undefined) {
				return val.toFixed(3);
			}
		},
	},
};
</script>

<style type="scss">
.zhjl_main {
	padding: 20px 0px 20px 0;
}

#zhjl .detail_style {
	color: #0e78c7;
}

.detail_style:hover {
	cursor: pointer;
}

#zhjl .el-dialog__body {
	padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderReport/zhjl.vue